export default function getViewerUrl (args) {
  return 'https://spaces.archilogic.com/3d/!'+args.sceneId
}